export const PREPACKAGE_SMART_FILL_EXPERIMENT = 'travel-prepackage-smart-fill-autocomplete';
export const PREPACKAGE_SMART_FILL_VARIANT = 'smart_fill';

export const getPrepackageAutocompleteVariant = (experimentVariant) =>
    experimentVariant === 'treatment' ? PREPACKAGE_SMART_FILL_VARIANT : undefined;

const splitAutocompleteUrl = (autocompleteUrl) => {
    const [baseUrl, ...queryParts] = autocompleteUrl.split('?');

    return {
        baseUrl,
        searchParams: new URLSearchParams(queryParts.join('?')),
    };
};

const stringifyAutocompleteUrl = (baseUrl, searchParams) => {
    const queryString = searchParams.toString();

    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

const updateAutocompleteSearchParams = (autocompleteUrl, update) => {
    const { baseUrl, searchParams } = splitAutocompleteUrl(autocompleteUrl);
    const existingQueryValues = searchParams.getAll('query');

    searchParams.delete('query');
    update(searchParams);

    for (const queryValue of existingQueryValues) {
        searchParams.append('query', queryValue);
    }

    return stringifyAutocompleteUrl(baseUrl, searchParams);
};

const appendPrepackageAutocompleteValue = (autocompleteUrl, key, value) => {
    if (!value) {
        return autocompleteUrl;
    }

    return updateAutocompleteSearchParams(autocompleteUrl, (searchParams) => {
        if (searchParams.getAll(key).includes(value)) {
            return;
        }

        searchParams.set(key, value);
    });
};

export const appendPrepackageAutocompleteParams = (autocompleteUrl, params) => {
    if (!params) {
        return autocompleteUrl;
    }

    return updateAutocompleteSearchParams(autocompleteUrl, (searchParams) => {
        for (const [key, value] of new URLSearchParams(params)) {
            searchParams.append(key, value);
        }
    });
};

export const appendPrepackageAutocompleteVariant = (autocompleteUrl, autocompleteVariant) => {
    if (!autocompleteVariant) {
        return autocompleteUrl;
    }

    return appendPrepackageAutocompleteValue(autocompleteUrl, 'autocompleteVariant', autocompleteVariant);
};
